import * as Switch from '@wandb/weave/components/Switch';
import React from 'react';
import {twMerge} from 'tailwind-merge';

export const SettingLogToggle = ({
  id,
  className,
  isChecked,
  onCheckedChange,
}: {
  id?: string;
  className?: string;
  isChecked: boolean;
  onCheckedChange: (newValue: any) => void;
}) => {
  return (
    <div className={twMerge('flex items-center gap-8', className)}>
      <Switch.Root
        id={id}
        aria-label="Log scale"
        checked={isChecked}
        onCheckedChange={onCheckedChange}
        size="small">
        <Switch.Thumb checked={isChecked} size="small" />
      </Switch.Root>
      <label htmlFor={id} className="text-base leading-[22px] text-moon-800">
        Log scale
      </label>
    </div>
  );
};
